<template>
    <div>
        <UserPicker ref="userPicker" @pick="handlePick"></UserPicker>
        <el-dialog title="设置代理员等级" :visible.sync="visible" width="500px">
            <el-form label-width="80px" ref="form" :model="form" :rules="rules">
                <el-form-item label="代理等级" prop="level_uuid">
                    <LevelSelector v-model="form.level_uuid"></LevelSelector>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible = false">取 消</el-button>
                <el-button type="primary" @click="handleConfirm">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import UserPicker from "@/components/UserPicker";
import LevelSelector from "@/components/LevelSelector";
import { setdl } from "@/api/member/list";
export default {
    components: { UserPicker, LevelSelector },
    data() {
        return {
            visible: false,
            form: {
                level_uuid: "",
            },
            rules: {
                level_uuid: [{ required: true, message: "请选择代理等级" }],
            },
            user_uuids: [],
        };
    },
    methods: {
        open() {
            this.$refs.userPicker.open();
        },
        handlePick(user_uuids) {
            this.user_uuids = user_uuids;
			this.visible = true;
        },
        handleConfirm() {
            this.$refs.form.validate((valid) => {
                if (!valid) return;
                setdl({
                    user_uuids: this.user_uuids,
                    level_uuid: this.form.level_uuid,
                }).then(({ code, error }) => {
                    if (code === 200) {
                        this.$message.success("设置成功");
                        this.visible = false;
                        this.$refs.userPicker.close();
						this.$emit('update');
                    } else {
                        this.$message.error(error.message);
                    }
                });
            });
        },
    },
};
</script>

<style></style>
